import axios from '@axios';
import { ErrorMessage } from '@/libs/Error';

export default class DocumentoFiscalClient {
  constructor() {
    this.api = axios;
    this.error = new ErrorMessage();
  }

  /**
   * Busca DANFE (PDF) e XML da nota fiscal via backend (proxy TOTVS pwDanfeBoletoSF).
   * @param {{ estabelecimentoid, notafiscalserie, notafiscalnumero }} payload
   * @returns {{ notaFiscal, arquivoPDF, arquivoXML }} base64
   */
  async danfeBoleto(payload) {
    try {
      const result = await this.api.post('documento-fiscal/danfe-boleto', payload);
      return result.data?.data || null;
    } catch (error) {
      const msg = error?.response?.data?.message;
      throw this.error.message(error, msg || 'Erro ao buscar documentos da nota fiscal');
    }
  }
}

/** Converte base64 em Blob e dispara o download no navegador. */
export function baixarBase64(base64, nomeArquivo, mimeType) {
  const bytes = atob(base64);
  const buffer = new Uint8Array(bytes.length);
  for (let i = 0; i < bytes.length; i += 1) buffer[i] = bytes.charCodeAt(i);
  const blob = new Blob([buffer], { type: mimeType });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = nomeArquivo;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  setTimeout(() => URL.revokeObjectURL(url), 10000);
}

/** Object URL local: o navegador nunca precisa acessar diretamente o ERP. */
export function pdfBase64ObjectUrl(base64) {
  const bytes = atob(base64);
  const buffer = new Uint8Array(bytes.length);
  for (let i = 0; i < bytes.length; i += 1) buffer[i] = bytes.charCodeAt(i);
  const blob = new Blob([buffer], { type: 'application/pdf' });
  const url = URL.createObjectURL(blob);
  setTimeout(() => URL.revokeObjectURL(url), 60000);
  return url;
}

/** Abre o PDF (base64) em uma nova aba. */
export function abrirPdfNovaAba(base64) {
  window.open(pdfBase64ObjectUrl(base64), '_blank');
}
